import { createContext, ReactNode, useContext, useMemo } from "react";
import { useSrmAuthenticatedContext } from "./srm-authentication-context";
import { SsoPassThruHttpClient } from "./sso-pass-thru-http-client";
import React from "react";

const SrmSsoPassThruHttpClientContext = createContext<SsoPassThruHttpClient | null>(null);

export const SrmSsoPassThruHttpClientContextProvider = ({ children }: { children: ReactNode }) => {
    const { getTokenFn } = useSrmAuthenticatedContext();
    const client = useMemo(() => new SsoPassThruHttpClient(getTokenFn), [getTokenFn]);

    return <SrmSsoPassThruHttpClientContext.Provider value={client}>
        {children}
    </SrmSsoPassThruHttpClientContext.Provider>;
};

export const useHttpClientContext = () => {
    const context = useContext(SrmSsoPassThruHttpClientContext);

    if (!context) {
        throw new Error("HttpClient context is not initialized.");
    }

    return context;
};
